import React, { useContext, useEffect } from "react";

import LocaleContext from "@/i18n";
import { RegistrationFormInteractionOutro } from "@/service/Model";
import TrackingService from "@/service/Tracking";

import SovendusDefaultGraphic from "./SovendusDefaultGraphic";
import * as Styled from "./styles";

interface Props {
  outro: RegistrationFormInteractionOutro;
}

const httpsUrl = (url?: string): string | undefined => {
  if (!url) {
    return undefined;
  }
  try {
    return new URL(url).protocol === "https:" ? url : undefined;
  } catch {
    return undefined;
  }
};

const PostRegistrationPromo: React.FC<Props> = ({
  outro,
}: Props): React.JSX.Element | null => {
  const promo = outro.promo;
  const code = promo?.trackingCode || outro.campaignId || "";
  const { translation } = useContext(LocaleContext);
  const linkUrl = httpsUrl(promo?.linkUrl);
  const show = !!promo?.enabled && !!linkUrl;

  useEffect(() => {
    if (show) {
      TrackingService.getInstance().trackOnPromoImpression(code);
    }
  }, []);

  if (!show) {
    return null;
  }

  const handleClick = (event: React.MouseEvent): void => {
    event.preventDefault();
    TrackingService.getInstance().trackOnPromoClick(code);
    window.open(linkUrl!, "_blank", "noopener,noreferrer");
  };

  return (
    <Styled.Card data-qa="registration.promo">
      <Styled.Title>
        {promo!.title || translation.promo.defaultTitle}
      </Styled.Title>
      <Styled.ImageBox>
        {promo!.image ? (
          <img
            src={promo!.image}
            alt={promo!.title || translation.promo.defaultTitle}
          />
        ) : (
          <SovendusDefaultGraphic />
        )}
      </Styled.ImageBox>
      <Styled.Body>{promo!.body || translation.promo.defaultBody}</Styled.Body>
      <Styled.Button
        href={linkUrl!}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        data-qa="registration.promo.button"
      >
        {promo!.buttonLabel || translation.promo.defaultButtonLabel}
      </Styled.Button>
    </Styled.Card>
  );
};

export default PostRegistrationPromo;
